<div class="container mobile-container container-space pb-0">
  <div class="col-12">
    <div class="search-section mb-3">
      <div class="search-container">
        <div class="search-input-wrapper">
          <input
            [class.searching]="isSearching"
            [formControl]="searchControl"
            [placeholder]="'Search' | translate"
            class="search-input"
            type="text">
          <div class="search-icon">
            <img alt="search"
                 height="20"
                 src="/icons/ic_search.svg"
                 width="20">
          </div>
          @if (searchControl.value && searchControl.value.length > 0) {
            <button
              (click)="clearSearch()"
              class="clear-search-btn"
              type="button">
              <img alt="clear"
                   height="20"
                   src="/icons/close-circle.svg"
                   width="20">
            </button>
          }
        </div>
      </div>
    </div>
    <!-- Active Order Status Cards -->
    @if (isActiveOrdersLoading && activeOrders && activeOrders.length > 0) {
      <div class="active-orders-container mb-3">
        <div class="active-orders-scroll">
          @for (placeholder of activeOrdersSkeletonPlaceholders; track $index) {
            <div class="active-order-card active-order-skeleton-card">
              <div class="order-card-content">
                <div class="order-status-column">
                  <span aria-hidden="true"
                        class="skeleton skeleton-line active-order-skeleton-status"></span>
                  <div class="order-products-images d-flex overflow-auto pe-2 hide-scrollbar">
                    @for (thumbPlaceholder of activeOrdersSkeletonProductPlaceholders; track thumbPlaceholder) {
                      <span aria-hidden="true"
                            class="skeleton active-order-skeleton-image"></span>
                    }
                  </div>
                </div>
                <div class="order-delivery-column">
                  <span aria-hidden="true"
                        class="skeleton skeleton-line active-order-skeleton-delivery-label"></span>
                  <span aria-hidden="true"
                        class="skeleton skeleton-line active-order-skeleton-delivery-value"></span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    } @else if (activeOrders && activeOrders.length > 0) {
      <div class="active-orders-container mb-3">
        <div class="active-orders-scroll">
          @for (factor of activeOrders; track factor.FactorId) {
            <div class="active-order-card">
              <div class="order-card-content">
                <!-- ستون وسط: وضعیت و عکس محصولات -->
                <div class="order-status-column">
                  <div class="order-status-header">
                    <span class="order-status-text">{{ getOrderStatusText(factor.Status) }}</span>
                  </div>
                  <div class="order-products-images d-flex overflow-auto pe-2 hide-scrollbar">
                    @for (factorOrder of factor.FactorOrders; track factorOrder.OrderId) {
                      <div class="image-wrapper position-relative">
                        <img
                          (error)="onImageError($event)"
                          (load)="imageLoadError = false"
                          [ngClass]="{ 'rounded-image': !imageLoadError, 'no-radius': imageLoadError }"
                          [src]="formatImage('', factorOrder.Order.ServicePrice.Service.Images[0])"
                          alt="preview"
                          height="40"
                          style="margin-left: 6px"
                          width="40">
                        <div class="badge-circle">{{ factorOrder.Order.Count }}</div>
                      </div>
                    }
                  </div>
                </div>
                <!-- ستون سوم: ساعت تحویل -->
                <div class="order-delivery-column">
                  <div class="delivery-time-label">{{ 'DeliveryByHour' | translate }}</div>
                  <div class="delivery-time-value">{{ deliveryTime(factor) }}</div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (isCategoriesLoading && !showSearchResults) {
      <div class="d-flex align-items-center justify-content-between">
        <div class="Title-box d-flex flex-column align-items-center justify-content-start">
          <span aria-hidden="true"
                class="skeleton skeleton-line"
                style="width: 150px; height: 20px; border-radius: 8px;"></span>
          <span aria-hidden="true"
                class="skeleton skeleton-line mt-2 d-lg-block d-none"
                style="width: 150px; height: 2px; border-radius: 4px;"></span>
        </div>
      </div>
      <div [ngClass]="{'sticky': isSticky}"
           class="position-fix d-flex flex-column">
        <div class="d-flex scroll-content px-1 py-3">
          <div class="parent-dessert">
            <div class="d-flex flex-row">
              @for (placeholder of categorySkeletonPlaceholders; track $index) {
                <div class="d-flex flex-column justify-content-around align-items-center card-dessert mt-2 skeleton-category-card">
                  <div aria-hidden="true"
                       class="skeleton skeleton-circle"
                       style="width: 45px; height: 45px; border-radius: 50%;"></div>
                  <div class="d-flex mt-2">
                    <span aria-hidden="true"
                          class="skeleton skeleton-line"
                          style="width: 60px; height: 14px; border-radius: 8px;"></span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="title-line">
          <span></span>
        </div>
      </div>
    } @else if (!showSearchResults) {
      <div class="d-flex align-items-center justify-content-between">
        <div class="Title-box d-flex flex-column align-items-center justify-content-start">
          <span>{{ 'Categories' | translate }}</span>
          <img class="mt-2 d-lg-block d-none"
               src="/icons/line-categories.svg">
        </div>
      </div>
      <div [ngClass]="{'sticky': isSticky}"
           class="position-fix d-flex flex-column">
        <div class="d-flex scroll-content px-1 py-3 ">
          <div class="parent-dessert">
            <div class="d-flex flex-row">
              @for (tag of categoryAndTags.Tags ?? []; track $index) {
                <div (click)="onTagClick(tag)"
                     [ngClass]="{
                       'selected': selectedUniqueIdentifier === tag.UniqueIdentifier || highlightedTags.has(tag.TagId)
                     }"
                     class="d-flex flex-column justify-content-around align-items-center card-dessert mt-2">
                  <img [src]="formatImage('', tag?.Icon)"
                       width="40">
                  <div class="d-flex">
                    <p>{{ tag.Title }}</p>
                  </div>
                </div>
              }
              @for (category of categoryAndTags.Categories; track $index) {
                <div (click)="onCategoryClick(category)"
                     [ngClass]="{
                     'selected': selectedUniqueIdentifier === category.UniqueIdentifier || highlightedCategories.has(category.CategoryId)
                   }"
                     class="d-flex flex-column justify-content-around align-items-center card-dessert mt-2">
                  <img [src]="formatImage('', category?.Icon)"
                       height="45"
                       width="45">
                  <div class="d-flex">
                    <p class="text-center">{{ category.Title }}</p>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="title-line">
          {{ getSelectedTitle() }}
          <span></span>
        </div>
      </div>
    }
    <!-- Search Results Title -->
    <div *ngIf="showSearchResults && searchControl.value"
         class="title-line">
      {{ 'Search' | translate }}: "{{ searchControl.value }}"
      <span></span>
    </div>
    <div class="d-flex flex-row scroll-product h-auto">
      <div class="d-flex w-100">
        <div class="services-grid">
          @if (isServicesLoading) {
            @for (placeholder of skeletonPlaceholders; track $index) {
              <div class="service-item">
                <app-service [isLoading]="true"></app-service>
              </div>
            }
          } @else if (services.length > 0) {
            @if (showSearchResults && searchControl.value) {
              <!-- Grouped Search Results by Category -->
              @for (group of getGroupedSearchResults(); track group.categoryName) {
                <div class="search-category-group">
                  <div class="category-header">
                    <h4>{{ 'Category' | translate }}: {{ group.categoryName }}</h4>
                  </div>
                  <div class="category-products">
                    @for (service of group.services; track $index) {
                      <div class="service-item">
                        <app-service (addToBasketClicked)="onServiceClicked($event)"
                                     [orders]="orders"
                                     [selectedServicePriceId]="selectedServicePriceId"
                                     [service]="service">
                        </app-service>
                      </div>
                    }
                  </div>
                </div>
              }
            } @else {
              <!-- Normal Product Display -->
              @for (service of services; track $index) {
                <div class="service-item">
                  <app-service (addToBasketClicked)="onServiceClicked($event)"
                               [orders]="orders"
                               [selectedServicePriceId]="selectedServicePriceId"
                               [service]="service">
                  </app-service>
                </div>
              }
            }
          } @else if (searchControl.value && !isSearching) {
            <div class="no-search-results">
              <p>{{ 'NoResultsFoundFor' | translate }} "{{ searchControl.value }}"</p>
            </div>
          }
        </div>
        <div class="card-parent">
          @if (!isMobile) {
            @if (isServicesLoading) {
              <div class="basket-skeleton">
                <span aria-hidden="true"
                      class="skeleton skeleton-line basket-skeleton-title"></span>
                <span aria-hidden="true"
                      class="skeleton skeleton-line basket-skeleton-subtitle"></span>
                <div aria-hidden="true"
                     class="skeleton basket-skeleton-summary"></div>
                <div aria-hidden="true"
                     class="skeleton basket-skeleton-summary"></div>
                <div aria-hidden="true"
                     class="skeleton basket-skeleton-footer"></div>
              </div>
            } @else if (services.length > 0) {
              <app-basket (ordersChange)="getOrders()"
                          [orders]="orders"
                          class="new-style container-space-style order-style"></app-basket>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

